const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

let sessionId = null;

function uuidv4() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // RFC-4122 v4 fallback (no crypto.randomUUID, e.g. older embedding pages).
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Returns a stable per-page session id. A full page reload loads this module
 * again, so the backend conversation cache gets a fresh key while the visible
 * chat state also starts empty.
 *
 * @returns {string}
 */
export function getSessionId() {
    if (!sessionId || !UUID_RE.test(sessionId)) {
        sessionId = uuidv4();
    }

    return sessionId;
}
